import { useState, useEffect } from 'react';
import { BASEAPIURL, BASEURL, getInstPhotoFullURL, UPLOADNODEURL } from '../../../../config';
import { useTranslation } from 'react-i18next';

import CourseListBlock from '../../../Helper/CourseListBlock';
// import CourseListBlockQB from '../../../Helper/CourseListBlockQB';

function MyFavouritePage() {
    const { t } = useTranslation();
    const [isLoded, SetisLoded] = useState(false);
    const [showShare, setshowShare] = useState(false);
    const [ShowType, SetShowType] = useState('courses');
    const [FavCourse, SetFavCourse] = useState([]);
    
    const GerFavorites = async (targetType) => {
        try {
            const res = await fetch(`${BASEAPIURL}/student/GerFavoritesList`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
                body: JSON.stringify({
                    targetType,
                    usertype: localStorage.getItem('usertype'),
                }),
            });
            const resJson = await res.json();
            SetisLoded(true);
            if (resJson.data) {
                switch (targetType) {
                    case 'eproducts':
                    case 'courses':
                    case 'instructor':
                        SetFavCourse(resJson.data);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        GerFavorites('courses');
    }, []);
    return (
        <>
            {/* {ShowType} */}
            <div className="ry_instr_shadow p-4" style={{ display: isLoded ? '' : 'none' }}>
                <h4 className="std_header_on_page">{t('myWishlist')}</h4>
                <div className="row">
                    <div className="col-md-12">
                        <div
                            className="col-md-12 mt-4"
                            style={{
                                backgroundColor: 'lightgrey',
                                borderRadius: '10px',
                            }}
                        >
                            {/* #{ShowType}# */}
                            <ul className="nav" style={{ text: 'black' }}>
                                {/* <li className="col-md-1"></li> */}
                                <li className="nav-item col-md-2 p-1 text-center">
                                    <a
                                        className={ShowType === 'courses' ? 'selectedTabProfile' : ''}
                                        href="/"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            SetShowType('courses');
                                            GerFavorites('courses');

                                        }}
                                    >
                                        {t('courses')}
                                    </a>
                                </li>
                                <li className="nav-item col-md-2 p-1 text-center">
                                    <a
                                        className={ShowType === 'eproducts' ? 'selectedTabProfile' : ''}
                                        href="/"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            SetShowType('eproducts');
                                            GerFavorites('eproducts');
                                        }}
                                    >
                                        {t('eproducts')}
                                    </a>
                                </li>
                                <li className="nav-item col-md-2 p-1 text-center">
                                    <a
                                        className={ShowType === 'instructor' ? 'selectedTabProfile' : ''}
                                        href="/"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            SetShowType('instructor');
                                            GerFavorites('instructor');

                                        }}
                                    >
                                        Instructor
                                    </a>
                                </li>
                                {/* <li className="col-md-1"></li> */}
                            </ul>
                        </div>
                        {/* For Favarate instructor */}
                        <div style={{ display: ShowType === 'instructor' ? '' : 'none' }}>
                            <div
                                className="col-md-12 std_header_on_page"
                                style={{
                                    backgroundColor: '#f0eeee',
                                    marginTop: '50px',
                                    borderRadius: '5px',
                                    padding: '20px',
                                    textAlign: 'center',
                                    display: FavCourse && FavCourse.length === 0 ? '' : 'none',
                                }}
                            >
                                <p>You haven't created your favourites yet!</p>
                                <p>
                                    click&nbsp;
                                    <i className="far fa-heart text-danger"></i>
                                    &nbsp;& start building your list now
                                </p>
                            </div>

                            <div className='row'>
                                {FavCourse.map((s) => (
                                    <div className="col-md-4">
                                        <div className="appie-features-content ListCourse bg-white">
                                            <div className="imgBox">
                                            <a href={`/instructor/profile/${s.slug}`} className="d-block">
                                                <img
                                                    src={getInstPhotoFullURL(s.tid, 'instructor')}
                                                    alt={s.name}
                                                    title={s.name}
                                                    className="courseimgsj"
                                                />
                                            </a>
                                            <span className="curpoint">
                                                <i className="fa fa-star"></i> {s.rating}
                                            </span>
                                            </div>

                                            <div className="hoverContent1 contentBox">
                                                <div style={{ clear: 'both' }}></div>
                                                <h6 className="mb-0 text-center">
                                                    <a className="CLB_course_title-OLD" href={`/instructor/profile/${s.slug}`}>
                                                        {s.name}
                                                    </a>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>

                        </div>
                        {/* For Favarate instructor */}
                        {/* For Favarate course */}
                        <div style={{ display: ShowType === 'courses' ? '' : 'none' }}>
                            <div
                                className="col-md-12 std_header_on_page"
                                style={{
                                    backgroundColor: '#f0eeee',
                                    marginTop: '50px',
                                    borderRadius: '5px',
                                    padding: '20px',
                                    textAlign: 'center',
                                    // display: FavCourse && FavCourse.length === 0 ? '' : 'none',
                                    display: FavCourse && FavCourse.filter((s) => s.section === 'courses').length === 0 ? '' : 'none'

                                }}
                            >
                                <p>You haven't created your favourites yet!</p>
                                <p>
                                    click&nbsp;
                                    <i className="far fa-heart text-danger"></i>
                                    &nbsp;& start building your list now
                                </p>
                            </div>

                            <div className="mt-3">
                                <div className="row">
                                    {FavCourse
                                        .filter((s) => s.section === 'courses')
                                        .map((s) => (
                                        <div className="col-md-4" key={s.image}>
                                            {/* ##{s.section}## */}
                                            <CourseListBlock
                                                singi={s}
                                                UPLOADNODEURL={UPLOADNODEURL}
                                                showShare={showShare}
                                                setshowShare={setshowShare}
                                                setShareThisURL={BASEURL}
                                                BASEURL={BASEURL}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/* For Favarate course */}
                        </div>

                         <div style={{ display: ShowType === 'eproducts' ? '' : 'none' }}>
                            <div
                                className="col-md-12 std_header_on_page"
                                style={{
                                    backgroundColor: '#f0eeee',
                                    marginTop: '50px',
                                    borderRadius: '5px',
                                    padding: '20px',
                                    textAlign: 'center',
                                    // display: FavCourse && FavCourse.length === 0 ? '' : 'none',
                                    display: FavCourse && FavCourse.filter((s) => s.section === 'eproducts').length === 0 ? '' : 'none'
                                }}
                            >
                                <p>You haven't created your favourites yet!</p>
                                <p>
                                    click&nbsp;
                                    <i className="far fa-heart text-danger"></i>
                                    &nbsp;& start building your list now
                                </p>
                            </div>

                            <div className="mt-3">
                                <div className="row">
                                    {FavCourse
                                        .filter((s) => s.section === 'eproducts')
                                        .map((s) => (
                                        <div className="col-md-4" key={s.image}>
                                            {/* $$$##{s.section}##$$$$$$$ */}
                                            <CourseListBlock
                                                singi={s}
                                                UPLOADNODEURL={UPLOADNODEURL}
                                                showShare={showShare}
                                                setshowShare={setshowShare}
                                                setShareThisURL={BASEURL}
                                                BASEURL={BASEURL}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/* For Favarate course */}
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default MyFavouritePage;
